import { createContext, useContext } from "react";

import type { MapBounds, MapTone } from "./MapView.types";

export type MapContentRegistry = {
  register: (id: string, bounds: MapBounds) => void;
  unregister: (id: string) => void;
};

export const MapContentContext = createContext<MapContentRegistry | null>(null);

export function useMapContentRegistry(): MapContentRegistry | null {
  return useContext(MapContentContext);
}

export type MapPalette = Record<MapTone, string>;

// Concrete colors resolved from the theme tokens, for the parts Google draws
// itself (a polyline stroke takes no CSS variable).
export const MapPaletteContext = createContext<MapPalette | null>(null);

export function useMapPalette(): MapPalette | null {
  return useContext(MapPaletteContext);
}
